import { UI, VStack, HStack } from '@genial/components';
import { BoxBorder, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';
import { FlatList } from 'react-native';

import { TimeLineItem, TimeLineItemProps } from './components/TimeLineItem';

export const ItemSeparator: React.FC = () => {
  return (
    <Box
      height={Spacing['stack.xxs']}
      py="stack.quarck"
      ml="3px"
      borderLeftStyle="dashed"
      borderLeftWidth="1px"
      borderColor="neutral.dark"
    />
  );
};

interface BaseTimelineProps {
  title: string;
  timeline: TimeLineItemProps[] | undefined;
}

interface UnableToCloseTimelineProps extends BaseTimelineProps {
  ableToClose?: false;
  isOpen?: boolean;
  onToggle?: () => void;
}

interface AbleToCloseTimelineProps extends BaseTimelineProps {
  ableToClose: true;
  isOpen: boolean;
  onToggle: () => void;
}

export type TimelineProps = UnableToCloseTimelineProps | AbleToCloseTimelineProps;

export const Timeline: React.FC<TimelineProps> = ({
  title,
  timeline,
  isOpen,
  ableToClose,
  onToggle,
}) => {
  if (!timeline || timeline.length === 0) {
    return null;
  }

  return (
    <VStack space="stack.xxxs" p="inset.xs" bg="background" borderRadius={BoxBorder.heavy}>
      <HStack justifyContent="space-between" alignItems="center">
        <UI.Text variant="semibold">{title}</UI.Text>
        {ableToClose && (
          <UI.IconButton
            p={0}
            icon={isOpen ? 'ChevronUp' : 'ChevronDown'}
            testId="open-product-category"
            onPress={onToggle}
            iconColor="neutral.black"
          />
        )}
      </HStack>
      {(!!isOpen || !ableToClose) && (
        <FlatList
          data={timeline}
          keyExtractor={(item) => item?.label}
          ItemSeparatorComponent={ItemSeparator}
          renderItem={({ item }) => <TimeLineItem {...item} />}
          showsVerticalScrollIndicator={false}
        />
      )}
    </VStack>
  );
};
